export const columnLabels = {
    id: 'ID',
    created_at: 'Дата создания',
    open_date: 'Дата открытия',
    planned_close_date: 'Планируемая дата закрытия',
    close_date: 'Фактическая дата закрытия',
    reason_close_request: 'Причина закрытия',
    organisation_id: 'Компания',
    department_id: 'Отдел',
    city: 'Город',
    planned_start_date: 'Планируемая дата выхода',
    author: 'Автор заявки',
    author_position: 'Должность автора',
    assigner_id: 'Исполнитель',
    is_template: 'Черновик',
    job_title: 'Название должности',
    positions_count: 'Количество позиций',
    rate: 'Ставка',
    vacancy_reason: 'Причина открытия вакансии',
    subordinates_count: 'Количество подчинённых',
    tasks: 'Основные задачи',
    expected_results: 'Ожидаемые результаты',
    functional_responsibilities: 'Функциональные обязанности',
    reporting_details: 'Отчетность',
    work_schedule: 'График работы',
    work_start_time: 'Время начала работы',
    work_end_time: 'Время окончания работы',
    field_vs_office: 'Место работы',
    requires_travel: 'Требуются командировки',
    travel_details: 'Детали командировок',
    requires_relocation: 'Требуется переезд',
    salary_structure: 'Структура оплаты',
    trial_salary: 'Зарплата на испытательный срок',
    post_trial_salary: 'Зарплата после испытательного срока',
    compensate_phone: 'Компенсация за телефон',
    compensate_car: 'Компенсация за авто',
    workplace_address: 'Адрес места работы',
    gender: 'Пол',
    age: 'Возраст',
    marital_status: 'Семейное положение',
    requires_license: 'Требуется водительское удостоверение',
    license_categories: 'Категории ВУ',
    requires_car: 'Наличие личного авто',
    education_levels: 'Уровень образования',
    computer_skills_level: 'Навыки ПК',
    skills_1c: 'Навыки работы в 1С',
    software_skills: 'Навыки работы с ПО',
    language_skills: 'Знание языков',
    experience_description: 'Опыт работы',
    personal_traits: 'Личностные качества',
    professional_skills: 'Профессиональные навыки',
    preferred_companies: 'Желаемые компании',
    unwanted_companies: 'Нежелательные компании',
    other_conditions: 'Прочие условия',
    status: 'Статус',
    candidate_status: 'Статус кандидата',
    actions: 'Действия',
    completion_work: 'Дата завершения',
    result_candidate: 'Результат собеседования',
    failure_reason: 'Причина отказа'
};

export const STATUSES = {
    new: {
        title: 'Новая',
        color: '#52c41a' // Зеленый - активная, новая вакансия
    },
    in_progress: {
        title: 'В работе',
        color: '#fa8c16' // Оранжевый - активный поиск
    },
    stopped: {
        title: 'Приостановлена',
        color: '#1890ff' // Синий - временно приостановлена
    },
    closed: {
        title: 'Закрыта',
        color: '#8c8c8c' // Серый - завершена
    },
    hanging: {
        title: 'Зависшая',
        color: '#722ed1' // Фиолетовый - требует внимания
    },
    template: {
        title: 'Черновик',
        color: '#595959' // Темно-серый - черновик
    }
};

export const FAILURE_REASONS = {
    'no_show': 'Не пришел на собеседование',
    'irrelevant_experience': 'Нерелевантный опыт работы',
    'irrelevant_salary': 'Нерелевантный доход',
    'no_contact': 'Не выходит на связь',
    'not_interested_product': 'Не интересен товар',
    'unsuitable_schedule': 'Не подходит график работы',
    'not_actively_searching': 'Не актуален поиск работы',
    'not_interested_functionality': 'Не интересен функционал',
    'long_commute': 'Далеко добираться',
    'failed_test_assignment': 'Не прошел тестовое задание',
    'vacancy_closed': 'Вакансия закрыта',
    'other_requirements': 'Не подходит по другим требованиям'
};